export const SET_LEAVE_BALANCE = "SET_LEAVE_BALANCE";
export const SET_APPLY_LEAVE_RESPONSE = "SET_APPLY_LEAVE_RESPONSE";
export const SET_LEAVE_HISTORY = "SET_LEAVE_HISTORY";
export const SET_LEAVE_TYPES = "SET_LEAVE_TYPES";
export const SET_LEAVE_DURATION = "SET_LEAVE_DURATION";